export const catalogos = [
  {
    id: 1,
    nameImg: { pt: `Catálogo LUMIARQ`, en: `LUMIARQ Catalog`, es: `Catálogo LUMIARQ`,fr:`Catalogue LUMIARQ`, it:`Catalogo LUMIARQ`, zh:`LUMIARQ 目录`},
    download: 'https://drive.google.com/file/d/1SPbjraT715EeaNnV0Xau5k6bfC3NajuR/view?usp=drive_link',
    linkImg: '/images/downloads/brochuras/cataLumiarq.png',
  },
    {
    id: 2,
    nameImg: {  pt: "Catálogo R-DESIGN", en: "R-DESIGN Catalog", es: "Catálogo R-DESIGN", fr: "Catalogue R-DESIGN", it: "Catalogo R-DESIGN", zh: "R-DESIGN目录"},
    download: 'https://drive.google.com/file/d/1Jcsr-1ZI4alvQZc4sQO5ytO-065tOZQ9/view?usp=drive_link',
    linkImg: '/images/downloads/brochuras/r-design.png',
  },
  {
    id: 3,
    nameImg: { pt: "Catálogo LIVOLO",en: "LIVOLO Catalog",es: "Catálogo LIVOLO",fr: "Catalogue LIVOLO",it: "Catalogo LIVOLO",zh: "LIVOLO目录"},
    download: 'https://drive.google.com/file/d/10j_EE9fEIUrMd0tVafCPdSc0tfiMRiSx/view?usp=drive_link',
    linkImg: '/images/downloads/brochuras/Catalogo_LIVOLO.png',
  },
  {
    id: 4,
    nameImg: { pt: "Catálogo Suntree", en: "Suntree Catalog",es: "Catálogo Suntree",fr: "Catalogue Suntree",  it: "Catalogo Suntree", zh: "Suntree目录"},
    download: 'https://drive.google.com/file/d/11WTS8PNBZPXXqAbdQvqNaHy-u_gbry3P/view?usp=drive_link',
    linkImg: '/images/downloads/brochuras/CatalogoSuntree.png',
  },
  {
    id: 5,
    nameImg: { pt: "Catálogo Luz Hexagonal",en: "Hexagonal Light Catalog", es: "Catálogo Luz Hexagonal",fr: "Catalogue Luz Hexagonal",it: "Catalogo Luce Esagonale",  zh: "六角形灯具目录"},
    download: 'https://drive.google.com/file/d/1zsRHxwafz6Trm88cxDyhY4IEqqYgbf7c/view?usp=sharing',
    linkImg: '/images/downloads/brochuras/luz_hexagonal.png',
  },
  {
    id: 8,
    nameImg: { pt: "Tabela de preços R-DESIGN",en: "R-DESIGN Price List", es: "Tabla de precios R-DESIGN",fr: "Tableau des prix R-DESIGN",it: "Tabella prezzi R-DESIGN",  zh: "R-DESIGN价目表"},
    download: 'https://drive.google.com/file/d/1_7-Nen-qbt4emrd-uZYyF1YmURh9bbJd/view?usp=drive_link',
    linkImg: '/images/downloads/brochuras/TabelaPrecosRdesign.png',
  },
  {
      id: 6,
      nameImg:  {pt: "Catálogo Fan Light", en: "Fan Light Catalog", es: "Catálogo Fan Light", fr: "Catalogue Ventilateur lumineux", it: "Catalogo Fan Light", zh: "风扇灯目录"},
      download: 'https://drive.google.com/file/d/1znFW9hk83qw6HWDPzjaMgMAUYb3JOJnl/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/ventirdesign.png',
  },
  {
    id: 3,
    nameImg: { pt: `Tabela de preços`, en: `Price list`, es: `Lista de precios`,fr:`Liste de prix`, it:`Listino prezzi`, zh:`价格表`},
    download: 'https://drive.google.com/file/d/1IZ2pExK3PVANsQmnHdfLfUdpI_OdvTEC/view?usp=drive_link',
    linkImg: '/images/downloads/brochuras/tabela_precos.png',
  },    
  ];

  export const catalogos_especiais = [
    {
      id: 1,
      nameImg:{ pt: "Tabela preços Líquidos",en: "Fan Light Price List",es: "Tabla de precios Fan Light",fr: "Tableau des prix nets", it: "Tabella prezzi netti",zh: "净价表" },
      download: 'https://drive.google.com/file/d/1meDOcmnPFgQsw1XQJuk7NC9x_FnyxMJQ/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/tabela_precosL2026.png',
    },
    {
      id: 2,
      nameImg:  {pt: "Tabela Preços Fan Light", en: "Fan Light Catalog", es: "Catálogo Fan Light", fr: "Tableau des prix Fan Light", it: "Tabella prezzi Fan Light", zh: "风扇灯价格表"},
      download: 'https://drive.google.com/file/d/1re6uC_FBTHCbdoc-KOqI6g6VETCYbvMq/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/fan_light_precosL.png',
  }, 
  ];
  
  export const campanhas_especiais = [

  ];
  export const campanhas = [
    {
      id: 1,
      startDate: '2025-09-15',
      endDate: '2025-09-29',
      nameImg:{ pt: "De 15 de setembro a 29 de setembro", en: "From September 15 to September 29", es: "Del 15 al 29 de septiembre",fr: "Du 15 au 29 septembre",it: "Dal 15 al 29 settembre",zh: "9月15日至9月29日" },
      download: 'https://drive.google.com/file/d/1wpdiOPM0It4iEBCTtmrdd0MZ6cDJIkQv/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/campanha_15_29setem.png',
    },
    {
      id: 2,
      startDate: '2025-09-23',
      endDate: '2025-10-07',
      nameImg:{ pt: "De 29 de setembro a 07 de outubro", en:"From September 29 to October 07",es:"Del 29 de septiembre al 07 de octubre", fr: "Du 29 septembre au 07 octobre",it: "Dal 29 settembre al 07 ottobre", zh: "9月29日至10月07日"},
      download: 'https://drive.google.com/file/d/1Ego9v60jeSRdUAW3-sC1ulI5E8vk8D3c/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/Campanha07.png',
    },
  ];

  export const brochures = [
    {
      id: 1,
      nameImg: { pt: 'Perfis para Fita LED', en: `LED strip profiles`, es: `Perfiles de tiras LED`,fr:`Profils de bandes LED`, it:`Profili per strisce LED`, zh:`LED 灯条型材`},
       download: 'https://drive.google.com/file/d/1vQLxjlhAGBAl2qOSVSTv-HoCrNi-_YFE/view?usp=drive_link',
       linkImg: '/images/downloads/brochuras/perfis.png',
    },
    {
      id: 2,
      nameImg: { pt: 'Calhas Magnéticas', en: `Magnetic rails`, es: `Carriles magnéticos`,fr:`Rails magnétiques`, it:`Binari magnetici`, zh:`磁轨`},
      download: 'https://drive.google.com/file/d/1N3H_-kjxyqrmj-Ig9C_oK7m8stThMP2a/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/ilu-magne.png',
    },
    {
      id: 3,
      nameImg: { pt: 'Iluminação de piscina', en: 'Pool lighting',  es: 'Iluminación de piscina', fr: 'Éclairage de piscine', it: 'Illuminazione per piscina',  zh: '游泳池照明'
      }, 
      download: 'https://drive.google.com/file/d/1xmbD12qoBx_vNFilqD3BVXSRR5wQO2OP/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/piscinas.png',
    },
    {
      id: 4,
      nameImg: { pt: 'Iluminação publicitária', en: 'Advertising lighting',es: 'Iluminación publicitaria',fr: 'Éclairage publicitaire', it: 'Illuminazione pubblicitaria',zh: '广告照明'},
      download: 'https://drive.google.com/file/d/1zjTc5Nhne1NNqM6DdBtwtRbRvT6MQjN4/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/ilu-publi.png',
    },
    {
      id: 5,
      nameImg: { pt: 'Fontes de alimentação', en: `LED power supplies`, es: `Fuentes de alimentación LED`,fr:`Alimentations LED`, it:`Alimentatori a LED`, zh:`LED 电源`},
      download: 'https://drive.google.com/file/d/16WEUQpT3g1r-QebY2rWdXz3Al9RidWdd/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/fonte-ali.png',
    },
    {
      id: 6,
      nameImg: { pt: 'Controladores para Fita LED', en: `LED Strip Drivers`, es: `Controladores de tiras LED`,fr:`Pilotes de bandes LED`, it:`Driver per strisce LED`, zh:`LED 灯条驱动器`},
      download: 'https://drive.google.com/file/d/1-fxVjHcNWVFpu0Vb7kjpIBDEVSIUzU7Y/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/contro-fitas.jpg',
    },
     {
      id: 7,
      nameImg:  {  pt: "Iluminação Exterior", en: "Outdoor Lighting", es: "Iluminación Exterior",fr: "Éclairage Extérieur",it: "Illuminazione Esterna", zh: "户外照明"},
      download: 'https://drive.google.com/file/d/1PnfacoFeWZrVuz_PoVW1Q-6rb70s5ew6/view?usp=drive_link',
      linkImg: '/images/downloads/brochuras/Ilu-exte.png',
     }
  ];

export const flyers = [
    {
      id: 1,
      nameImg: { pt: 'Desdobrável Calha Magnética', en: `Magnetic trough leaflet`, es:`Folleto de la cubeta magnética`,fr:`Brochure sur les cuvettes magnétiques`, it:`Opuscolo sulle cuvette magnetiche`, zh:`磁性槽宣传单`},
      download: '/pdfs/brochuras/ADVANCE_Desdobravel-Calha-Magnetica.pdf',
      linkImg: 'https://ik.imagekit.io/advance/downloads/Desdobravel-calha-magnetica-764x1024.webp?updatedAt=1730909444416',
    },
    {
      id: 2,
      nameImg: { pt: 'Desdobrável Iluminação Exterior', en: `Leaflet Outdoor Lighting`, es:`Folleto Iluminación exterior`,fr:`Dépliant Éclairage extérieur`, it:`Volantino Illuminazione per esterni`, zh:`户外照明传单`},
      download: '/pdfs/brochuras/ADVANCE_Desdobravel-Iluminacao-Exterior.pdf',
      linkImg: 'https://ik.imagekit.io/advance/downloads/Desdobravel-iluminacao-exterior-764x1024.webp?updatedAt=1742384922122',
    
    },
    {
      id: 8,
      nameImg: { pt: 'Desdobrável Produtos R-Electric', en: `R-Electric Product Leaflet`, es:`Folleto del producto R-Electric`,fr:`Fiche produit R-Electric`, it:` Opuscolo del prodotto R-Electric`, zh:`R-Electric 产品宣传册`},
      download: '/pdfs/brochuras/ADVANCE_Desdobravel-Produtos-R-Electric.pdf',
      linkImg: 'https://ik.imagekit.io/advance/downloads/Desdobravel-Produtos-R-Electric-764x1024.webp?updatedAt=1730909558033',
    },
    
    {
      id: 10,
      nameImg: { pt: 'Desdobrável Iluminação de Piscina', en: `Pool Lighting Leaflet`, es:`Folleto sobre iluminación de piscinas`,fr:`Brochure sur l'éclairage des piscines`, it:`Opuscolo sull'illuminazione della piscina`, zh:`泳池照明小册子`},
      download: '/pdfs/brochuras/Piscina-Maxled.pdf',
      linkImg: 'https://ik.imagekit.io/advance/downloads/Ilu-Piscina.webp?updatedAt=1730909558109'
    },
    {
      id: 11,
      nameImg: { pt: 'Desdobrável Downlight TINO', en: `Downlight TINO leaflet`, es:`Downlight TINO folleto`,fr:`Brochure sur le projecteur TINO`, it:`Foglio illustrativo del Downlight TINO`, zh:`筒灯 TINO 传单`},
      download: '/pdfs/brochuras/TINO.pdf',
      linkImg: 'https://ik.imagekit.io/advance/downloads/Tino.webp?updatedAt=1736160617985'
    },
  ];